import { CognitoError } from "src/errors";

const COGNITO_ERROR_MESSAGES: { [key: string]: string } = {
  UserNotFoundException: "User not found",
  NotAuthorizedException: "Incorrect username or password",
  InvalidParameterException: "Invalid parameter",
  InvalidPasswordException: "Invalid password",
  UsernameExistsException: "Account already exists, use sign in",
  CodeMismatchException: "Invalid code",
  ExpiredCodeException: "Code expired",
  LimitExceededException: "Limit exceeded",
  PasswordResetRequiredException: "Password reset required",
  TooManyRequestsException: "Too many requests",
  ResourceNotFoundException: "Resource not found",
  UserNotConfirmedException: "Email is not verified",
  UserLambdaValidationException: "Invalid request"
};

const DETAILED_COGNITO_ERROR_MESSAGES: { [key: string]: string } = {
  "User account not found":
    "Invalid Email Address\nIf you think your account does not exist, you may request for account creation.",
  "User not found":
    "Invalid email or password.\nIf you think you do not have an account, request for account creation\nIf you have forgotten your old password, you may reset password\n",
  "Invalid Email":
    "Invalid email or password\nIf you think you do not have an account, request for account creation.\nIf you have forgotten your old password, you may reset password\n",
  "Incorrect username or password":
    "Invalid email or password\nIf you think you do not have an account, request for account creation\nIf you have forgotten your old password, you may reset password.\n"
};

export class CognitoHelper {
  private static formatCognitoErrorMessage(errorMessage: string): string {
    const defaultCognitoErrorMessageRegex = /.*failed with error\s*/;
    const formattedMessage = errorMessage.replace(defaultCognitoErrorMessageRegex, "").trim();
    return formattedMessage.endsWith(".") ? formattedMessage.slice(0, -1) : formattedMessage;
  }

  static resolveError(error: unknown): CognitoError | Error {
    if (error instanceof Object && "code" in error) {
      const cognitoError = error as CognitoError;
      const formattedMessage =
        cognitoError.code === "UserLambdaValidationException"
          ? this.formatCognitoErrorMessage(cognitoError.message)
          : COGNITO_ERROR_MESSAGES[cognitoError.code] || "An unexpected authentication error occurred";

      return new CognitoError(DETAILED_COGNITO_ERROR_MESSAGES[formattedMessage] || formattedMessage, cognitoError.code);
    }
    return new Error("An unexpected error occurred");
  }
}
